import { useEffect } from 'react'
import { AGAMI_VIZ_MODE_DEFAULT, AGAMI_VIZ_MODE_KEY } from '../utils/constants/localStorage.constants'
import { useStoredState } from './useStoredState'
import { useScreenBreakpoint } from './toolkit'

type VizMode = 'cards' | 'list' | string // Ajuster selon les valeurs possibles

export const useAgamiVizMode = (): [VizMode, (value: VizMode) => void] => {
  const screenBreakpoint = useScreenBreakpoint()

  const [vizMode, setVizMode] = useStoredState({
    key: AGAMI_VIZ_MODE_KEY,
    defaultValue: AGAMI_VIZ_MODE_DEFAULT,
  })

  useEffect(() => {
    if (screenBreakpoint === 'sm') {
      setVizMode('cards')
    }
  }, [screenBreakpoint, setVizMode])

  return [vizMode, setVizMode]
}
